import React, { useState } from "react";
import Grid2 from '@mui/material/Unstable_Grid2';
import { Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Breadcrumb, IconAlert } from "../../components";
import { Box, Item, Anchor } from "../../components/elements";
import { CardHeader } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";
import data from "../../data/blocks/alerts.json";

export default function Alerts() {
    const [visibleAlerts, setVisibleAlerts] = useState(
        data?.bootstrap.reduce((acc, _, index) => ({ ...acc, [index]: true }), {})
    );

    const handleClose = (index) => {
        setVisibleAlerts(prev => ({ ...prev, [index]: false }));
    };

    // Map Bootstrap variants to MUI severities
    const mapVariantToSeverity = (variant) => {
        const mapping = {
            'danger': 'error',
            'success': 'success',
            'warning': 'warning',
            'info': 'info',
            'primary': 'info',
            'secondary': 'info',
            'light': 'info',
            'dark': 'info'
        };
        return mapping[variant] || 'info';
    };

    return (
        <PageLayout>
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12 }}>
                    <Breadcrumb title={ data?.pageTitle }>
                        {data?.breadcrumb.map((item, index) => (
                            <Item key={ index } className="mc-breadcrumb-item">
                                {item.path ? <Anchor className="mc-breadcrumb-link" href={ item.path }>{ item.text }</Anchor> : item.text }
                            </Item>
                        ))}
                    </Breadcrumb>
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <Box className="mc-card">
                        <CardHeader title="MUI alerts" />
                        {data?.bootstrap.map((item, index) => (
                            visibleAlerts[index] && (
                                <Alert
                                    key={ index }
                                    severity={ mapVariantToSeverity(item.variant) }
                                    onClose={() => handleClose(index)}
                                    sx={{ mb: 2 }}
                                >
                                    { item.label }
                                </Alert>
                            )
                        ))}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <Box className="mc-card">
                        <CardHeader title="custom alerts" />
                        {data?.custom.map((item, index) => (
                            <IconAlert
                                key={ index }
                                classes={ item.classes }
                                icon={ item.icon }
                                title={ item.title }
                                text={ item.text }
                            />
                        ))}
                    </Box>
                </Grid2>
            </Grid2>
        </PageLayout>
    )
}